import styled from 'styled-components'

const ShopItemStyle = styled.div`
	//! Big
	--bigShortInfoPadding: var(--sp4x) var(--sp6x);
	--bigShortInfoNameWidth: 100%;
	--bigImageMargin: var(--sp17-5x) auto var(--sp13x);
	--bigProductImageWidth: 83.4%;
	--bigItemWidth: 49%;

	//! Normal
	--normalShortInfoPadding: var(--sp4x);
	--normalShortInfoNameWidth: 100%;
	--normalImageMargin: var(--sp4x) auto var(--sp8x);
	--normalProductImageWidth: 73.5%;
	--normalItemWidth: 47.9%;

	//! Medium
	--mediumShortInfoPadding: var(--sp2x);
	--mediumShortInfoNameWidth: var(--sp42x);
	--mediumImageMargin: var(--sp8x) auto var(--sp5x);
	--mediumProductImageWidth: 82%;
	--mediumItemWidth: 50%;

	//! Product
	--productShortInfoPadding: var(--sp4x);
	--productShortInfoNameWidth: 100%;
	--productImageMargin: var(--sp8x) auto var(--sp6x);
	--productProductImageWidth: 83.3%;
	--productItemWidth: 32.3%;

	--priceMargin: var(--sp3x);
	--oldPriceMargin: 0 var(--sp2x) 0 var(--sp4x);

	//! for all <-------------------- Start -------------------->
	background-color: var(--cream);
	border-radius: var(--sp6x);
	margin: var(--sp1-5x);
	transition: var(--trTime2);

	.gender-icon {
		z-index: 1;
	}

	.price-cont {
		display: flex;
		flex-wrap: wrap;
		margin-top: var(--priceMargin);

		.oldPrice {
			margin: var(--oldPriceMargin);
			text-decoration: line-through;
		}
	}

	.link {
		display: flex;
		flex-direction: column;
	}

	.productName {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.imageCont {
		.image {
			object-fit: cover;
		}
	}

	.productImage {
		transition: var(--trTime2);
	}

	@media (hover: hover) {
		&:hover {
			.link {
				.productImage {
					transform: scale(1.1);
				}
			}
		}
	}

	.shortInfoWrap {
		flex-direction: column;
	}

	//! for all <--------------------- End --------------------->

	&.normal {
		width: var(--normalItemWidth);
		.link {
			.shortInfoWrap {
				padding: var(--normalShortInfoPadding);

				.productName {
					max-width: var(--normalShortInfoNameWidth);
				}
			}

			.productImage {
				width: var(--normalProductImageWidth);
				padding-top: var(--normalProductImageWidth);
				margin: var(--normalImageMargin);
				.imageCont {
					.image {
						object-fit: contain;
					}
				}
			}
		}
	}

	&.medium {
		width: var(--mediumItemWidth);
		.link {
			.shortInfoWrap {
				padding: var(--mediumShortInfoPadding);
				.productName {
					max-width: var(--mediumShortInfoNameWidth);
				}
			}

			.productImage {
				width: var(--mediumProductImageWidth);
				padding-top: var(--mediumProductImageWidth);
				margin: var(--mediumImageMargin);
				.imageCont {
					.image {
						object-fit: contain;
					}
				}
			}
		}
	}

	&.bigItem {
		width: var(--bigItemWidth);
		.link {
			.shortInfoWrap {
				padding: var(--bigShortInfoPadding);
				.productName {
					max-width: var(--bigShortInfoNameWidth);
				}
			}
			.productImage {
				width: var(--bigProductImageWidth);
				padding-top: var(--bigProductImageWidth);
				margin: var(--bigImageMargin);
				.imageCont {
					object-fit: contain;
				}
			}
		}
	}

	&.productPage {
		width: var(--productItemWidth);
		.link {
			.shortInfoWrap {
				padding: var(--productShortInfoPadding);
				.productName {
					max-width: var(--productShortInfoNameWidth);
				}
			}
			.productImage {
				width: var(--productProductImageWidth);
				padding-top: var(--productProductImageWidth);
				margin: var(--productImageMargin);
				.imageCont {
					object-fit: contain;
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		//! Big
		--bigShortInfoPadding: var(--sp3x);
		--bigImageMargin: var(--sp14x) auto var(--sp16x);
		--bigProductImageWidth: 86.8%;
		--bigItemWidth: calc(50% - var(--spSize) * 2);

		//! Normal
		--normalShortInfoPadding: var(--sp3x);
		--normalImageMargin: var(--sp9x) auto var(--sp7x);
		--normalProductImageWidth: 67.4%;
		--normalItemWidth: calc(50% - var(--spSize) * 2);

		//! Product
		--productShortInfoPadding: var(--sp3x);
		--productImageMargin: var(--sp8x) auto var(--sp5x);
		--productProductImageWidth: 70%;
		--productItemWidth: 32.4%;

		--priceMargin: var(--sp2x);
		--oldPriceMargin: 0 var(--sp2x) 0 var(--sp3x);

		margin: var(--spSize);
		border-radius: var(--sp5x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		//! Big
		--bigShortInfoPadding: var(--sp2x) var(--sp2-5x);
		--bigImageMargin: var(--sp10x) auto var(--sp14x);
		--bigProductImageWidth: 84.2%;
		--bigItemWidth: calc(50% - var(--spSize) * 2);

		//! Normal
		--normalShortInfoPadding: var(--sp2x) var(--sp2-5x);
		--normalImageMargin: var(--sp6x) auto;
		--normalProductImageWidth: 65%;
		--normalItemWidth: calc(50% - var(--spSize) * 2);

		//! Product
		--productShortInfoPadding: var(--sp2x) var(--sp2-5x);
		--productImageMargin: var(--sp7x) auto var(--sp6x);
		--productProductImageWidth: 65%;
		--productItemWidth: 32.1%;

		--priceMargin: var(--sp2x);
		--oldPriceMargin: 0 var(--spSize) 0 var(--sp2x);

		margin: var(--spSize);
		border-radius: var(--sp4x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		//! Big
		--bigShortInfoPadding: var(--sp3-5x) var(--sp3x);
		--bigImageMargin: var(--sp10x) auto var(--sp15x);
		--bigProductImageWidth: 86.1%;
		--bigItemWidth: 100%;

		//! Normal
		--normalShortInfoPadding: var(--sp2x);
		--normalImageMargin: var(--sp7x) auto var(--sp6x);
		--normalProductImageWidth: 62.7%;
		--normalItemWidth: calc(100% - var(--spSize) * 2);

		//! Product
		--productShortInfoPadding: var(--sp2x);
		--productImageMargin: var(--sp6x) auto var(--sp5x);
		--productProductImageWidth: 54%;
		--productItemWidth: 31.6%;

		--priceMargin: var(--sp2x);
		--oldPriceMargin: 0 var(--spSize) 0 var(--sp2x);

		margin: var(--spSize);
		border-radius: var(--sp3x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		//! Big
		--bigShortInfoPadding: var(--sp2x);
		--bigImageMargin: var(--sp13x) auto var(--sp12x);
		--bigProductImageWidth: 75%;
		--bigItemWidth: calc(100% - var(--spSize) * 2);

		//! Normal
		--normalShortInfoPadding: var(--sp2x);
		--normalImageMargin: var(--sp7x) auto var(--sp4x);
		--normalProductImageWidth: 63.7%;
		--normalItemWidth: calc(50% - var(--spSize) * 2);

		//! Product
		--productShortInfoPadding: var(--sp2x);
		--productImageMargin: var(--sp4x) auto var(--sp3x);
		--productProductImageWidth: 60%;
		--productItemWidth: 47.7%;

		--priceMargin: var(--spSize);
		--oldPriceMargin: 0 var(--spSize) 0 var(--sp2x);

		margin: var(--spSize);
		border-radius: var(--sp3x);
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		//! Big
		--bigShortInfoPadding: var(--sp2x);
		--bigImageMargin: var(--sp8x) auto var(--sp5x);
		--bigProductImageWidth: 64.5%;
		--bigItemWidth: calc(100% - var(--spSize) * 2);

		//! Normal
		--normalShortInfoPadding: var(--sp2x);
		--normalImageMargin: var(--sp8x) auto var(--sp5x);
		--normalProductImageWidth: 64.5%;
		--normalItemWidth: calc(100% - var(--spSize) * 2);

		//! Product
		--productShortInfoPadding: var(--sp2x);
		--productImageMargin: var(--sp8x) auto var(--sp5x);
		--productProductImageWidth: 64.5%;
		--productItemWidth: 100%;

		--priceMargin: var(--spSize);
		--oldPriceMargin: 0 var(--spSize) 0 var(--sp2x);

		margin: var(--spSize);
		border-radius: var(--sp2x);
	}
`

export default ShopItemStyle
